import { render, staticRenderFns } from "./QuestionOptions.vue?vue&type=template&id=3ecbae7a&scoped=true&lang=pug"
import script from "./QuestionOptions.vue?vue&type=script&lang=js"
export * from "./QuestionOptions.vue?vue&type=script&lang=js"
import style0 from "./QuestionOptions.vue?vue&type=style&index=0&id=3ecbae7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbae7a",
  null
  
)

export default component.exports